import React, { useEffect} from 'react';
import Slider from '../slides/Slider'
import { getLatestPlaylists } from '../../actions/PlaylistActions'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';


function NewVideos(props) {

    const dispatch = useDispatch()

    const navigate = useNavigate()

    const { latestPlaylists} = useSelector(state => state.latestPlaylists)
  
  
    useEffect(()=>{ 
        if (!latestPlaylists || !latestPlaylists.length){
            dispatch(getLatestPlaylists())
        }
  
    },[dispatch])


    const clickHandler = (item) => {
        localStorage.setItem('video_id', item.video.id)
        localStorage.setItem('playlist_id', item.id)
        localStorage.setItem('group_id', item.group_id)
        if(props.user) {
            navigate(encodeURI(`/home?g=${item.group_id}&p=${item.id}&v=${item.video.id}`,  {replace: false} ))
        } else {
            localStorage.setItem("path", encodeURI(`/home?g=${item.group_id}&p=${item.id}&v=${item.video.id}`))
            navigate('/login')
        }
    }


    return (
        <div className="col-12">
            <div className='position-relative'>
                    {
                        latestPlaylists && latestPlaylists && latestPlaylists.length ?
                        <Slider
                            num = {7}
                            type = {5}
                            showTitle = {true}
                            tvData={latestPlaylists}
                            slideClickHandler={clickHandler}
                            slideTitle = {"New  Playlists"}
                            // showAllHandler = {viewAllHandler}
                        /> : ""
                    }
            </div>
        </div>
    );
}

export default NewVideos;